var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect } from 'react';
import { ClientOnlyContent } from '../../components/atoms/ClientOnlyContent';
import { MainLayout } from '../../components/layouts/MainLayout';
import { initialDataSlice } from '../../store/initialData/initialData.slice';
import { connect } from 'react-redux';
import { useGALeadEvent } from '../../hooks/useGALeadEvent.hook';
import { useScript } from '../../hooks/useScript.hook';
import { Container } from '../../uikit/grid';
import { Spacer } from '../../uikit/misc/Spacer';
var mapStateToProps = function (state) { return ({
    placementId: initialDataSlice.selectors.getPlacementId(state),
    loanAmount: initialDataSlice.selectors.getAmount(state),
    isTestMode: initialDataSlice.selectors.getIsTestMode(state),
}); };
export var HypoFriendPageRaw = function (_a) {
    var placementId = _a.placementId, loanAmount = _a.loanAmount, isTestMode = _a.isTestMode;
    useScript('https://hypofriend.de/widgets/js/app.js');
    var onLeadCreated = useGALeadEvent();
    useEffect(function () {
        window.__hypofriend__ = {
            onLeadCreated: function () {
                onLeadCreated();
            },
        };
        return function onUnmount() {
            window.__hypofriend__ = undefined;
        };
    }, [onLeadCreated]);
    return (React.createElement(MainLayout, null,
        React.createElement(Container, { disableGutters: function (theme) { return theme.breakpoints.down('lg'); } },
            React.createElement(Spacer, { size: 3 }),
            React.createElement(ClientOnlyContent, null,
                React.createElement("hypofriend-calculator", __assign({ locale: "de" }, (typeof placementId !== 'undefined' && {
                    'tracking-id': placementId,
                }), (typeof loanAmount !== 'undefined' && {
                    'property-price': loanAmount,
                }), (typeof isTestMode === 'boolean' && { testing: isTestMode }), { "skip-calculation": true }))))));
};
export var HypoFriendPage = connect(mapStateToProps)(HypoFriendPageRaw);
